import get from 'lodash/get';
import { IconTypes, ImageThemes, Themes } from "../../interface/index.js";
$ const {
  title,
  subTitle,
  imageURLs = [],
  theme = Themes.DEFAULT,
  imageTheme = ImageThemes.ROUNDED,
  notification,
  overflowMenu,
  disabled,
  icon
} = input;
$ const singleImageUrl = imageURLs[0];
$ const multipleImageUrls = imageURLs.slice(0, 4);
<div class=`group-card group-card--${theme.toLowerCase()} ${disabled?.value ? 'group-card--disabled' : ''}` aria-label=`${disabled?.value ? disabled.accessibilityLabel : ''}` on-click('emit', 'click', input)>
  <div class="group-card__content">
    <if(imageTheme === ImageThemes.MULTIPLE)>
      <div class="group-card__image-grid">
        <if(!!multipleImageUrls.length)>
          <for|url, index| of=multipleImageUrls>
            <img src=url alt=`${title}-${index}` class="group-card__image-grid-item" loading="lazy">
          </for>
        </if>
        <else>
          <ebay-image-placeholder/>
        </else>
      </div>
    </if>
    <else-if(imageTheme === ImageThemes.ROUNDED || imageTheme === ImageThemes.CIRCLE)>
      <div class=`group-card__image-single group-card__image-single--${imageTheme.toLowerCase()}`>
        <if(singleImageUrl)>
          <img src=singleImageUrl alt=title loading="lazy">
        </if>
        <else>
          <ebay-image-placeholder/>
        </else>
      </div>
    </else-if>
    <else-if(imageTheme === ImageThemes.ICON && icon)>
      <div class='group-card__icon'>
        <${icon}/>
      </div>
    </else-if>
    <div class="group-card__title">
      <span class="group-card__main-title">
        ${title}
      </span>
      <if(subTitle)>
        <span class="group-card__sub-title">
          ${subTitle}
        </span>
      </if>
    </div>
  </div>
  <div class="group-card__action">
    <if(notification && notification.count > 0)>
      <div class="group-card__notification">
        <ebay-badge number=notification.count aria-label=notification.accessibilityLabel/>
      </div>
    </if>
    <if(overflowMenu && !!overflowMenu.menuItems && !!overflowMenu.menuItems.length)>
      $ const menuItems = get(overflowMenu, 'menuItems', []);
      $ const accessibilityLabel = get(overflowMenu, 'accessibilityLabel', 'Overflow Menu');
      <ebay-menu-button class="group-card__menu" variant="overflow" a11y-text=accessibilityLabel on-select('emit', 'menu-select', menuItems) disabled=disabled?.value>
        <for|item| of=menuItems>
          $ const actionName = get(item, 'action', '');
          $ const iconType = get(item, 'iconType', '');
          $ const switchButton = get(item, 'switchButton', '');
          <@item class="group-card__menu-item" data-action=(switchButton ? null : actionName)>
            <div class="group-card__menu-item-content">
              <if(iconType && iconType === IconTypes.CHAT)>
                <ebay-chat-16-icon/>
              </if>
              <if(iconType && iconType === IconTypes.PENCIL)>
                <ebay-pencil-16-icon/>
              </if>
              <if(iconType && iconType === IconTypes.NOTIFICATION)>
                <ebay-notification-16-icon/>
              </if>
              <if(iconType && iconType === IconTypes.SAVE)>
                <ebay-heart-filled-16-icon/>
              </if>
              <if(iconType && iconType === IconTypes.DELETE)>
                <ebay-delete-16-icon/>
              </if>
              <p>
                ${item.title}
              </p>
            </div>
            <if(switchButton)>
              <ebay-switch class="group-card__menu-item-switch-button" on-change("emit", 'menu-update', item)/>
            </if>
          </@item>
        </for>
      </ebay-menu-button>
    </if>
  </div>
</div>